import { api } from "@/lib/api";

let _cache;

export function signingConfigured() {
  if (!_cache) {
    _cache = api
      .get("/signing/status")
      .then((r) => !!r.data?.configured)
      .catch(() => false);
  }
  return _cache;
}
